import { Transform } from "class-transformer";
import { IsBoolean, IsOptional } from "class-validator";

export class AcordFormOptions {
    @IsOptional()
    @IsBoolean()
    @Transform(({ value }) => value === "true" || value === "1")
    preventFlatten?: boolean;
}
